import React from 'react';
import CurrencyWrapper from './pricing/CurrencyWrapper';
import { currencyLocaleFormatter } from '../../util/currencyFormatter';

export type Price = {
  currencyCode: string;
  centAmount: number;
  fractionDigits: number;
};

type CurrencyProps = {
  price: Price;
  discountedPrice?: Price;
  locale?: string;
  currency?: string;
};

const Currency = ({
  price,
  discountedPrice,
  locale = 'en-IE',
  currency = 'EUR',
}: CurrencyProps) => (
  <CurrencyWrapper
    fractionDigits={price.fractionDigits}
    typeSize={2}
    listCents={price.centAmount}
    discountCents={discountedPrice ? discountedPrice.centAmount : undefined}
    currencyCode={currency}
    locale={currencyLocaleFormatter(locale)}
  />
);

export default Currency;
